import React from 'react';
import { Link } from 'react-router-dom';
import { COMPARE_MAX } from '../../domain/compare/compareStore';

interface CompareFloatingBarProps {
  compareIds: number[];
}

// 플로팅 비교 바 — 비교함에 1개 이상 담기면 노출 (2026-07-07)
export const CompareFloatingBar: React.FC<CompareFloatingBarProps> = ({ compareIds }) => {
  if (compareIds.length === 0) return null;
  return (
    <Link
      to="/compare"
      className="fixed bottom-[72px] left-1/2 z-[60] flex -translate-x-1/2 items-center gap-2 rounded-full bg-ink px-4 py-2.5 text-[12.5px] font-extrabold tracking-tight text-white shadow-ca-cta md:bottom-6"
    >
      단지 비교 {compareIds.length}/{COMPARE_MAX}
      <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
      </svg>
    </Link>
  );
};
